const libPictView = require('pict-view');
const libLayout = require('./PictView-Layout.js');
const libSig = require('./PictView-Signature.js');
let libMarked = null;
try { libMarked = require('marked'); } catch (e) { libMarked = null; }

const _ViewConfiguration =
{
	ViewIdentifier: 'Conversation',
	DefaultRenderable: 'Conversation-Display',
	CSS: /*css*/`
		.cst-conv { max-width: 980px; margin: 0 auto; }
		.cst-turn { margin-bottom: 18px; padding: 0; border-radius: 8px; overflow: hidden; }
		.cst-turn-head
		{
			display: flex; align-items: baseline; gap: 10px;
			padding: 8px 14px; font-size: 12px;
			border-bottom: 1px solid transparent;
		}
		.cst-turn-head-kind { font-weight: 600; text-transform: uppercase; letter-spacing: 0.04em; }
		.cst-turn-head-time { color: var(--theme-color-text-secondary, #5b6376); font-family: monospace; }
		.cst-turn-head-meta { color: var(--theme-color-text-secondary, #5b6376); margin-left: auto; }
		.cst-turn-body { padding: 12px 14px; font-size: 14px; line-height: 1.55; }

		.cst-turn-userprompt { background: #eef7f1; border: 1px solid #cae5d6; }
		.cst-turn-userprompt .cst-turn-head { color: #1f5b3a; border-bottom-color: #cae5d6; }
		.cst-turn-userprompt-harness { display: none; }
		.cst-show-attachments .cst-turn-userprompt-harness { display: block; }
		.cst-harness-reminder
		{
			display: none;
			background: #fdf6e3; border-left: 3px solid var(--theme-color-status-warning, #c8a93a);
			padding: 6px 10px; margin: 0 0 8px 0;
			font-size: 11px; color: #6b5a1a; font-style: italic;
		}
		.cst-show-attachments .cst-harness-reminder { display: block; }
		.cst-harness-reminder-tag { font-weight: 600; font-style: normal; margin-right: 6px; color: #8a6e1a; text-transform: uppercase; letter-spacing: 0.04em; font-size: 10px; }

		.cst-turn-assistant { background: var(--theme-color-background-secondary, #fafbfd); border: 1px solid var(--theme-color-border-default, #dde2ee); }
		.cst-turn-assistant .cst-turn-head { color: var(--theme-color-text-primary, #2c3140); border-bottom-color: var(--theme-color-border-default, #dde2ee); }
		.cst-turn-assistant-final
		{
			background: #f0f5ff;
			border: 1px solid #b9cdf0;
			border-left: 4px solid var(--theme-color-brand-primary, #4a7ad6);
		}
		.cst-turn-assistant-final .cst-turn-head { color: #1e3d80; border-bottom-color: #b9cdf0; background: #e3edff; }
		.cst-turn-assistant-intermediary
		{
			background: var(--theme-color-background-secondary, #fafbfd);
			border: 1px dashed #cdd2dc;
			opacity: 0.92;
			display: none;
		}
		.cst-show-intermediaries .cst-turn-assistant-intermediary { display: block; }
		.cst-turn-assistant-intermediary .cst-turn-head { color: var(--theme-color-text-secondary, #5b6376); }
		.cst-turn-assistant-intermediary .cst-turn-body { font-size: 13px; color: var(--theme-color-text-secondary, #4a5066); }

		.cst-turn-toolresult { background: #fbfaff; border: 1px solid #e1ddee; display: none; }
		.cst-show-tools .cst-turn-toolresult { display: block; }

		.cst-turn-attachment { background: #fbfbfd; border: 1px dashed #c7ccd9; display: none; font-size: 12px; color: var(--theme-color-text-secondary, #5b6376); }
		.cst-show-attachments .cst-turn-attachment { display: block; }

		.cst-turn-system { background: #fff7f7; border: 1px dashed #e3b0b0; font-size: 12px; color: #7a3a3a; display: none; }
		.cst-show-attachments .cst-turn-system { display: block; }

		.cst-gap
		{
			display: flex; align-items: center; gap: 12px;
			margin: 14px 0;
			padding: 6px 14px;
			color: var(--theme-color-text-secondary, #5b6376);
			font-size: 12px;
			font-style: italic;
		}
		.cst-gap-line { flex: 1 1 auto; height: 1px; background: repeating-linear-gradient(90deg, var(--theme-color-border-default, #b0b6c2) 0 6px, transparent 6px 12px); }

		.cst-thinking
		{
			background: #f0f1f6;
			border-left: 3px solid #6f88c7;
			padding: 8px 12px;
			margin: 8px 0;
			font-style: italic;
			font-size: 13px;
			color: var(--theme-color-text-secondary, #4a5066);
			white-space: pre-wrap;
			display: none;
		}
		.cst-show-attachments .cst-thinking { display: block; }

		.cst-text { white-space: pre-wrap; }
		.cst-text p { margin: 0 0 0.7em 0; }
		.cst-text pre { background: var(--theme-color-text-primary, #1d2230); color: var(--theme-color-border-light, #e3e6ee); padding: 10px 12px; border-radius: 6px; overflow-x: auto; font-size: 12px; }
		.cst-text code { background: var(--theme-color-background-tertiary, #eef0f5); padding: 1px 5px; border-radius: 3px; font-size: 12px; }
		.cst-text pre code { background: transparent; padding: 0; color: inherit; font-size: 12px; }

		.cst-tools-strip { margin-top: 10px; display: none; flex-direction: column; gap: 4px; }
		.cst-show-tools .cst-tools-strip { display: flex; }
		.cst-tool-result-inline { display: none; }
		.cst-show-tools .cst-tool-result-inline { display: block; }
		.cst-turn-assistant-tooluse { display: none; }
		.cst-show-tools .cst-turn-assistant-tooluse { display: block; }
		.cst-turn-assistant-thinking { display: none; }
		.cst-show-attachments .cst-turn-assistant-thinking { display: block; }
		.cst-tool-chip
		{
			display: flex; align-items: center; gap: 8px;
			padding: 5px 10px;
			background: var(--theme-color-background-panel, #fff);
			border: 1px solid var(--theme-color-border-default, #dde2ee);
			border-left: 3px solid var(--theme-color-brand-accent, #b07acc);
			border-radius: 4px;
			font-size: 12px;
			cursor: pointer;
			line-height: 1.4;
		}
		.cst-tool-chip:hover { background: var(--theme-color-background-hover, #eaf2ff); }
		.cst-tool-chip-name { font-weight: 600; min-width: 60px; }
		.cst-tool-chip-input { color: var(--theme-color-text-primary, #2c3140); flex: 1 1 auto; font-family: monospace; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
		.cst-tool-chip-dur { color: var(--theme-color-text-secondary, #5b6376); font-family: monospace; flex: 0 0 auto; }
		.cst-tool-chip-err { color: var(--theme-color-status-error, #c0353a); }
		.cst-tool-chip.cst-tool-family-read   { border-left-color: var(--theme-color-brand-accent, #b07acc); }
		.cst-tool-chip.cst-tool-family-write  { border-left-color: #d18ba2; }
		.cst-tool-chip.cst-tool-family-bash   { border-left-color: #c87a3a; }
		.cst-tool-chip.cst-tool-family-search { border-left-color: #d4b94a; }
		.cst-tool-chip.cst-tool-family-agent  { border-left-color: #e07b3a; }

		.cst-tool-result-content
		{
			margin-top: 6px;
			padding: 10px 12px;
			background: var(--theme-color-text-primary, #1d2230); color: #d8dde8;
			font-family: monospace; font-size: 11px;
			border-radius: 4px;
			white-space: pre-wrap;
			max-height: 360px;
			overflow: auto;
		}
		.cst-tool-result-truncated { color: #d4b94a; font-style: italic; }
		.cst-tool-result-summary { font-size: 11px; color: var(--theme-color-text-secondary, #5b6376); }

		.cst-prompt-anchor { scroll-margin-top: 12px; }

		@media print
		{
			.cst-turn { break-inside: avoid; }
			.cst-tool-chip { cursor: default; }
		}
	`,
	Templates:
	[
		{
			Hash: 'Conversation-Display',
			Template: /*html*/`
<div class="cst-conv" id="Conversation-Inner"></div>`
		}
	],
	Renderables:
	[
		{
			RenderableHash: 'Conversation-Display',
			TemplateHash:   'Conversation-Display',
			ContentDestinationAddress: '#Conversation-Container'
		}
	]
};

class PictViewConversation extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		this.pict.CSSMap.injectCSS();
		this._buildBody();
		return super.onAfterRender(pRenderable, pAddress, pRecord, pContent);
	}

	_buildBody()
	{
		let tmpSession = this.pict.AppData.Session;
		if (!tmpSession || !tmpSession.Turns) return;

		let tmpL = this.pict.AppData.Layout || {};
		let tmpClasses = ['cst-conv-inner'];
		if (tmpL.ShowTools)          tmpClasses.push('cst-show-tools');
		if (tmpL.ShowAttachments)    tmpClasses.push('cst-show-attachments');
		if (tmpL.ShowIntermediaries) tmpClasses.push('cst-show-intermediaries');

		let tmpInner = document.getElementById('Conversation-Inner');
		if (tmpInner) tmpInner.className = 'cst-conv ' + tmpClasses.join(' ');

		let tmpHTML = '';
		let tmpRenderedPrompt = {};
		for (let i = 0; i < tmpSession.Turns.length; i++)
		{
			let tmpT = tmpSession.Turns[i];
			if (tmpT.PromptId && !tmpRenderedPrompt[tmpT.PromptId])
			{
				tmpRenderedPrompt[tmpT.PromptId] = true;
				tmpHTML += '<div id="Conversation-Prompt-' + tmpT.PromptId + '" class="cst-prompt-anchor"></div>';
			}
			tmpHTML += this._renderTurn(tmpT, i);
		}
		this.pict.ContentAssignment.assignContent('#Conversation-Inner', tmpHTML);
	}

	_renderTurn(pTurn, pIndex)
	{
		if (pTurn.Kind === 'gap')
		{
			return '<div class="cst-gap" id="Conversation-Turn-' + pIndex + '">'
				+ '<span class="cst-gap-line"></span>'
				+ '<span>idle ' + libLayout.formatDuration(pTurn.DurationMs) + '</span>'
				+ '<span>(' + new Date(pTurn.TimestampMs).toLocaleString() + ' → '
				+ new Date(pTurn.EndTimestampMs).toLocaleString() + ')</span>'
				+ '<span class="cst-gap-line"></span>'
				+ '</div>';
		}

		let tmpKindClass = 'cst-turn-' + pTurn.Kind.replace('-', '');
		if (pTurn.Kind === 'assistant')
		{
			if (pTurn.IsFinalReply)         tmpKindClass += ' cst-turn-assistant-final';
			else if (pTurn.IsIntermediary)  tmpKindClass += ' cst-turn-assistant-intermediary';
			else if (pTurn.IsToolOnly)      tmpKindClass += ' cst-turn-assistant-tooluse';
			else if (pTurn.IsThinkingOnly)  tmpKindClass += ' cst-turn-assistant-thinking';
		}
		else if (pTurn.Kind === 'user-prompt' && pTurn.IsHarnessOnly)
		{
			tmpKindClass += ' cst-turn-userprompt-harness';
		}
		let tmpHead = this._headForTurn(pTurn);
		let tmpBody = this._bodyForTurn(pTurn);

		return '<div class="cst-turn ' + tmpKindClass + '" id="Conversation-Turn-' + pIndex + '">'
			+ tmpHead
			+ '<div class="cst-turn-body">' + tmpBody + '</div>'
			+ '</div>';
	}

	_headForTurn(pTurn)
	{
		let tmpKind = pTurn.Kind;
		let tmpKindLabel = ({
			'user-prompt': 'User',
			'assistant':   'Assistant',
			'tool-result': 'Tool result',
			'attachment':  'Attachment',
			'system':      'System'
		})[tmpKind] || tmpKind;
		if (tmpKind === 'assistant')
		{
			if (pTurn.IsFinalReply)        tmpKindLabel = 'Reply';
			else if (pTurn.IsIntermediary) tmpKindLabel = 'Working';
		}
		let tmpTime = pTurn.TimestampMs ? new Date(pTurn.TimestampMs).toLocaleString() : '';
		let tmpMeta = '';
		if (tmpKind === 'assistant')
		{
			let tmpToolCount = (pTurn.ToolUseIds || []).length;
			let tmpBits = [];
			if (pTurn.Model) tmpBits.push(pTurn.Model);
			if (tmpToolCount) tmpBits.push(tmpToolCount + ' tool call' + (tmpToolCount === 1 ? '' : 's'));
			if (pTurn.Usage && pTurn.Usage.output_tokens) tmpBits.push(pTurn.Usage.output_tokens + ' tok out');
			tmpMeta = tmpBits.join(' · ');
		}
		else if (tmpKind === 'user-prompt' && pTurn.DurationFromPrevMs)
		{
			tmpMeta = 'after ' + libLayout.formatDuration(pTurn.DurationFromPrevMs);
		}
		return '<div class="cst-turn-head">'
			+ '<span class="cst-turn-head-kind">' + tmpKindLabel + '</span>'
			+ '<span class="cst-turn-head-time">' + tmpTime + '</span>'
			+ '<span class="cst-turn-head-meta">' + libLayout.escapeHTML(tmpMeta) + '</span>'
			+ '</div>';
	}

	_bodyForTurn(pTurn)
	{
		let tmpHTML = '';
		let tmpToolChips = '';
		if (pTurn.HarnessReminders && pTurn.HarnessReminders.length)
		{
			for (let r = 0; r < pTurn.HarnessReminders.length; r++)
			{
				let tmpRem = pTurn.HarnessReminders[r];
				tmpHTML += '<div class="cst-harness-reminder">'
					+ '<span class="cst-harness-reminder-tag">' + libLayout.escapeHTML(tmpRem.Tag) + '</span>'
					+ libLayout.escapeHTML(tmpRem.Body)
					+ '</div>';
			}
		}
		for (let i = 0; i < pTurn.Blocks.length; i++)
		{
			let tmpB = pTurn.Blocks[i];
			if (tmpB.Type === 'text')
			{
				tmpHTML += '<div class="cst-text">' + this._renderMarkdown(tmpB.Text || '') + '</div>';
			}
			else if (tmpB.Type === 'thinking')
			{
				tmpHTML += '<div class="cst-thinking">' + libLayout.escapeHTML(tmpB.Text || '') + '</div>';
			}
			else if (tmpB.Type === 'tool_use')
			{
				tmpToolChips += this._renderToolChip(tmpB);
			}
			else if (tmpB.Type === 'tool_result')
			{
				tmpHTML += this._renderToolResult(tmpB);
			}
			else if (tmpB.Type === 'attachment')
			{
				tmpHTML += '<div>' + libLayout.escapeHTML(tmpB.AttachmentType) + ' — ' + libLayout.escapeHTML(tmpB.Summary || '') + '</div>';
			}
			else if (tmpB.Type === 'image')
			{
				tmpHTML += '<div><em>[image]</em></div>';
			}
			else if (tmpB.Type === 'system')
			{
				tmpHTML += '<div>' + libLayout.escapeHTML(tmpB.Subtype) + ' — ' + libLayout.escapeHTML(tmpB.Summary || '') + '</div>';
			}
		}
		if (tmpToolChips) tmpHTML += '<div class="cst-tools-strip">' + tmpToolChips + '</div>';
		return tmpHTML;
	}

	_renderToolChip(pBlock)
	{
		let tmpFamily = libSig.toolFamily(pBlock.Name);
		let tmpAgentLink = '';
		// If this is a Task/Agent call, find a matching subagent and offer drill-in.
		if (tmpFamily === 'agent')
		{
			let tmpSession = this.pict.AppData.Session;
			let tmpAgentId = this._findAgentForToolUse(pBlock, tmpSession);
			if (tmpAgentId)
			{
				tmpAgentLink = ' <a href="#" onclick="event.stopPropagation(); _Pict.views.AgentDetail.openAgent(\''
					+ tmpAgentId + '\'); return false;">↳ open agent</a>';
			}
		}
		return '<div class="cst-tool-chip cst-tool-family-' + tmpFamily + '" '
			+ 'onclick="_Pict.views.ToolDetail.openTool(\'' + pBlock.ToolUseId + '\')">'
			+ '<span class="cst-tool-chip-name">' + libLayout.escapeHTML(pBlock.Name || 'tool') + '</span>'
			+ '<span class="cst-tool-chip-input">' + libLayout.escapeHTML(pBlock.InputSummary || '') + tmpAgentLink + '</span>'
			+ '<span class="cst-tool-chip-dur">' + this._chipDurationLabel(pBlock) + '</span>'
			+ '</div>';
	}

	_chipDurationLabel(pBlock)
	{
		// Walk forward: find the matching tool_result for this id (via Session.Turns).
		let tmpDur = this._lookupToolDurationMs(pBlock.ToolUseId);
		if (tmpDur != null) return libLayout.formatDuration(tmpDur);
		return '';
	}

	_lookupToolDurationMs(pToolUseId)
	{
		let tmpSession = this.pict.AppData.Session;
		if (!tmpSession) return null;
		for (let i = 0; i < tmpSession.Turns.length; i++)
		{
			let tmpT = tmpSession.Turns[i];
			if (tmpT.Kind !== 'tool-result' && tmpT.Kind !== 'user-prompt') continue;
			for (let j = 0; j < tmpT.Blocks.length; j++)
			{
				let tmpB = tmpT.Blocks[j];
				if (tmpB.Type === 'tool_result' && tmpB.ToolUseId === pToolUseId)
				{
					return tmpB.DurationMs;
				}
			}
		}
		return null;
	}

	_findAgentForToolUse(pBlock, pSession)
	{
		// Heuristic: if the agent transcript was written close in time to this Task call.
		if (!pSession || !pSession.Agents) return null;
		let tmpAgentIds = Object.keys(pSession.Agents);
		// Pick the agent whose first timestamp is closest after the tool_use's parent assistant turn.
		// Without a hard link in the JSONL we approximate by best time match.
		// Look up the assistant turn that contains this tool_use.
		let tmpStartMs = null;
		for (let i = 0; i < pSession.Turns.length; i++)
		{
			let tmpT = pSession.Turns[i];
			if (tmpT.Kind !== 'assistant') continue;
			if ((tmpT.ToolUseIds || []).indexOf(pBlock.ToolUseId) !== -1) { tmpStartMs = tmpT.TimestampMs; break; }
		}
		if (tmpStartMs == null) return tmpAgentIds[0] || null;
		let tmpBestId = null;
		let tmpBestDelta = Infinity;
		for (let i = 0; i < tmpAgentIds.length; i++)
		{
			let tmpAg = pSession.Agents[tmpAgentIds[i]];
			let tmpDelta = Math.abs((tmpAg.FirstTimestampMs || 0) - tmpStartMs);
			if (tmpDelta < tmpBestDelta) { tmpBestDelta = tmpDelta; tmpBestId = tmpAgentIds[i]; }
		}
		// Only return if within ~2 minutes — otherwise we'd link random agents.
		return tmpBestDelta < 2 * 60 * 1000 ? tmpBestId : null;
	}

	_renderToolResult(pBlock)
	{
		let tmpDur = pBlock.DurationMs != null ? ' · ' + libLayout.formatDuration(pBlock.DurationMs) : '';
		let tmpName = pBlock.ToolName || 'tool';
		let tmpHeader = '<div class="cst-tool-result-summary">'
			+ libLayout.escapeHTML(tmpName) + tmpDur + (pBlock.IsError ? ' · <span class="cst-tool-chip-err">error</span>' : '')
			+ (pBlock.PersistedPath ? ' · spilled to ' + libLayout.escapeHTML(pBlock.PersistedPath) : '')
			+ '</div>';
		let tmpContent = '<div class="cst-tool-result-content">'
			+ libLayout.escapeHTML(pBlock.ContentText || '')
			+ (pBlock.ContentTruncated ? '\n\n<span class="cst-tool-result-truncated">[truncated]</span>' : '')
			+ '</div>';
		return '<div class="cst-tool-result-inline">' + tmpHeader + tmpContent + '</div>';
	}

	_renderMarkdown(pText)
	{
		if (!pText) return '';
		if (libMarked && typeof libMarked.parse === 'function')
		{
			try { return libMarked.parse(pText); } catch (e) { /* fallthrough */ }
		}
		return libLayout.escapeHTML(pText);
	}

	scrollToPrompt(pPromptId)
	{
		let tmpEl = document.getElementById('Conversation-Prompt-' + pPromptId);
		if (tmpEl)
		{
			tmpEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
			if (this.pict.views.Timeline) this.pict.views.Timeline.highlight(pPromptId);
		}
	}

	scrollToTurn(pIndex)
	{
		let tmpEl = document.getElementById('Conversation-Turn-' + pIndex);
		if (tmpEl) tmpEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
	}
}

module.exports = PictViewConversation;
module.exports.default_configuration = _ViewConfiguration;
